import AddressDeleteModal from 'components/AddressDeleteModal/container';

export default AddressDeleteModal;
